import {
    getTrendingVideoItems,
    getPersonalizedItems,
} from "../../fetch/graphql/requests/mlDrivenItems/library";
import { transformAllContentItems } from "../../utils/dataTransform/library";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { getUserFromCookie } from "../../utils/cookies/library";
import log from "../../utils/logger/library";
import { DEFAULT_SWIMLANE_LAYOUT } from "../LayoutFactory/constants";

function getUserObject() {
    const user = getUserFromCookie();
    return user ? user.id : "";
}

export const fetchVideoRecommendations = async (
    limit,
    path,
    contentId,
    layout = DEFAULT_SWIMLANE_LAYOUT,
    algorithmId = null
) => {
    const userId = getUserObject();
    const _algorithmId = algorithmId || "rec4you-short-form-videos";

    try {
        const result = userId
            ? await getPersonalizedItems(_algorithmId, userId, limit, contentId)
            : await getTrendingVideoItems(limit);

        const cardContentItems =
            result?.data?.personalizedItems?.nodes ||
            result?.data?.mlDrivenItems?.items ||
            [];

        const transformedContentItems = cardContentItems.length
            ? transformAllContentItems(cardContentItems)
            : [];
        const recommendations = transformedContentItems.length
            ? transformForLayouts(transformedContentItems, layout, path)
            : [];

        return recommendations;
    } catch (error) {
        log.error(
            "(fetchVideoRecommendations) error fetching recommended clips",
            error
        );
        return [];
    }
};
